import { SpeakingLevelBadge } from "../UI/SpeakingLevelBadge.tsx";
import { ActivePlanBadges } from "./ActivePlanBadges.tsx";
import { UserActivePlans } from "./useUserActivePlans.ts";

export function SpeakingLevelWithGroup({
  speakingLevel,
  userGroupName,
  activePlans,
}: {
  speakingLevel: string;
  userGroupName: string | null;
  activePlans?: UserActivePlans;
}) {
  return (
    <div className={"flex flex-col items-start gap-1"}>
      <div className={"flex flex-wrap items-center gap-1"}>
        <SpeakingLevelBadge level={speakingLevel} />
        {activePlans && <ActivePlanBadges activePlans={activePlans} />}
      </div>
      {userGroupName && (
        <span className={"text-xs text-slate-400"}>{userGroupName}</span>
      )}
    </div>
  );
}
